import { getContext } from 'svelte';
import { get } from '../data';
export const BUILDERS_CONTEXT = 'builders';
export function useBuilders() {
    return getContext(BUILDERS_CONTEXT);
}
export function createBuilderContext(endpoint) {
    return {
        builder: (builder) => {
            return get(endpoint('builder', new URLSearchParams({ builder })));
        }
    };
}
